export default __webpack_public_path__ + "static/media/usa.51e539d6.jpg";